/**
 * FH-A11Y batch 20 (2026-09-27): chat window (Freshchat) workaround for SR12.
 * The chat runs inside Freshworks' own frame, which the theme can't change, so Escape does nothing while
 * you're in it. This adds a "Close chat" button straight after the chat window: it's the next Tab stop when
 * you leave the chat, it only appears while the chat is open (and is only visible when it has focus), and it
 * closes the chat and puts focus back on the "Chat with us" button. Escape also closes the chat whenever
 * focus is on the page rather than inside the chat window.
 * Rollback: remove the batch 20 line at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch20) return;
  window.__fhA11yBatch20 = true;

  var btn = null;

  function widget() { return window.fcWidget; }
  function isOpen() {
    var w = widget();
    if (w && typeof w.isOpen === 'function') { try { return !!w.isOpen(); } catch (e) {} }
    var f = document.getElementById('fc_frame');
    return !!(f && f.classList.contains('fc-open'));
  }
  function launcher() { return document.getElementById('freshdeskwidgetcontainer'); }

  function closeChat() {
    var w = widget();
    if (w && typeof w.close === 'function') { try { w.close(); } catch (e) {} }
    var l = launcher();
    if (l) { try { l.focus({ preventScroll: true }); } catch (e) { l.focus(); } }
    sync();
  }

  function ensureButton() {
    var frame = document.getElementById('fc_frame');
    if (!frame) return null;
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fh-chat-close';
      btn.textContent = 'Close chat';
      btn.hidden = true;
      btn.addEventListener('click', closeChat);
      var st = document.createElement('style');
      st.textContent =
        '.fh-chat-close{position:fixed;right:15px;z-index:2147483647;padding:10px 16px;border:2px solid #10728b;' +
        'background:#fff;color:#10728b;font:14px/1.2 MessinaSansMono-Regular,monospace;letter-spacing:1px;' +
        'text-transform:uppercase;cursor:pointer;clip-path:inset(50%);width:1px;height:1px;overflow:hidden;white-space:nowrap}' +
        '.fh-chat-close:focus{clip-path:none;width:auto;height:auto;overflow:visible;outline:2px solid #10728b;outline-offset:2px}';
      document.head.appendChild(st);
    }
    if (btn.previousElementSibling !== frame) frame.insertAdjacentElement('afterend', btn);
    return btn;
  }

  function place() {
    var frame = document.getElementById('fc_frame');
    if (!btn || !frame) return;
    var r = frame.getBoundingClientRect();
    btn.style.top = Math.max(8, Math.round(r.top) - 52) + 'px';
  }

  function sync() {
    var b = ensureButton();
    if (!b) return;
    var open = isOpen();
    if (b.hidden === open) b.hidden = !open;
    if (open) place();
  }

  /* Escape anywhere on the page (not inside the chat frame: its keys never reach the page). */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !isOpen()) return;
    var a = document.activeElement;
    if (a && a.closest && a.closest('dialog[open], [role="dialog"][aria-modal="true"]') && !a.closest('#fc_frame')) return;
    e.preventDefault();
    closeChat();
  });
  document.addEventListener('focusin', function (e) { if (btn && e.target === btn) place(); });

  var bound = false;
  function bindWidgetEvents() {
    var w = widget();
    if (bound || !w || typeof w.on !== 'function') return;
    bound = true;
    try { w.on('widget:opened', function () { setTimeout(sync, 50); }); } catch (e) {}
    try { w.on('widget:closed', function () { setTimeout(sync, 50); }); } catch (e) {}
  }

  /* The chat loads only when first asked for, so keep watching for it. */
  var timer = 0;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; try { bindWidgetEvents(); sync(); } catch (e) {} }, 150);
  }
  function start() {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    setInterval(function () { if (document.getElementById('fc_frame')) sync(); }, 1000);
    window.addEventListener('resize', place);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
